import React from "react";
import * as agent from "../agent";

const Shutdown = () => (
    <div className="shutdown-page">
        <button className="shutdown-btn" onClick={agent.shutdown} ></button>
    </div>
);

export default Shutdown;



// WEBPACK FOOTER //
// ./src/components/Shutdown.js